import React from 'react';
export function MarqueeBanner() {
  const text = 'DESIGN · CODE · CREATE · EXPLORE · BUILD · EXPERIMENT · ';
  return <div className="py-6 border-t border-b border-border overflow-hidden" data-id="element-218">
      <div className="flex animate-marquee whitespace-nowrap" data-id="element-219">
        {Array.from({
        length: 4
      }).map((_, i) => <span key={i} className="font-display text-sm md:text-base font-bold tracking-widest text-muted-foreground/30 uppercase mx-0" data-id="element-220">
            {text}
          </span>)}
      </div>
    </div>;
}